'use client';

import type { Experiment } from '@/app/utils/experimentation';
import { getExperimentName } from '@/app/utils/experimentation';
import { useTreatments } from '@/app/treatments-provider';
import TrackTreatment from '@/components/utils/track-treatment';

export default function SsrExperimentClientComponent({
  experiment,
  children,
}: {
  experiment: string | Experiment;
  children: React.ReactNode;
}) {
  const treatments = useTreatments();
  const experimentName = getExperimentName(experiment);
  const treatment = treatments[experimentName] ?? treatments.control;

  return (
    <>
      {children}
      <TrackTreatment treatment={treatment} />
    </>
  );
}
